export const getGlobalStats = (dispatch: any, doUpdate: boolean) =>
  dispatch({ type: "GET_GLOBALSTATS", doUpdate });

export const getGlobalStatsSuccess = (stats: any[]) => ({
  type: "GET_GLOBALSTATS_SUCCESS",
  stats,
});

export const getGlobalStatsFailure = (error: Error) => ({
  type: "GET_GLOBALSTATS_FAILURE",
  error,
});

export const clearGlobalStats = (dispatch: any) =>
  dispatch({ type: "CLEAR_GLOBALSTATS" });
